import { AfterViewInit, Component, HostListener } from '@angular/core';
import { CoordinatorService } from 'coordinator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
    private readonly _skipLoginPromptKey = 'memowl.skipLoginPrompt';
    title = 'patentka';
    isMobile = window.innerWidth < 768;

    stageManagerComponent: any;
    stageLicenseComponent: any;
    sectionFooterComponent: any;

    dialogHubUploadComponent: any;
    dialogStartComponent: any;

    dialogPdfComponent: any;
    dialogBulkComponent: any;

    dialogConnectionStep1Component: any;
    dialogConnectionStep2Component: any;
    dialogConnectionStep3Component: any;
    dialogConnectionStep4Component: any;

    dialogDeleteComponent: any;
    dialogUserDetailComponent: any;
    dialogInProgressActionsComponent: any;
    dialogOpenProjectInProgressComponent: any;
    dialogSystemComponent: any;
    dialogConnectionOnlineComponent: any;
    dialogConnectionScriptComponent: any;
    dialogLogsComponent: any;
    dialogAttachmentComponent: any;
    dialogAttachmentEditComponent: any;
    dialogImageComponent: any;
    dialogHelpInContextComponent: any;
    dialogMouseOverComponent: any;
    dialogMenuComponent: any;
    dialogMessageComponent: any;
    dialogSaveComponent: any;
    dialogCloudCacheConflictComponent: any;
    dialogSaveHitsetComponent: any;
    dialogSearchViewsComponent: any;
    dialogSearchBinaryTreeComponent: any;
    dialogConfirmComponent: any;
    dialogExportComponent: any;
    dialogShareComponent: any;
    dialogProjectListComponent: any;
    dialogSortComponent: any;
    dialogKeywordComponent: any;
    dialogKeywordGroupEditorComponent: any;
    dialogItemDetailPanelSelectionComponent: any;
    dialogTeamInvitationComponent: any;
    dialogTeamGenerateCodeComponent: any;
    dialogTeamChangeRoleComponent: any;
    dialogTeamGroupInvitationComponent: any;
    dialogMoreComponent: any;
    dialogFilterPanel2Component: any;
    dialogTagsEditorComponent: any;
    dialogRatingsEditorComponent: any;
    dialogLoginComponent: any;
    dialogLogoutComponent: any;
    dialogInvitationCodeAcceptComponent: any;
    dialogUserIdentificatorComponent: any;
    dialogCloudErrorComponent: any;
    dialogColumnCPreviewComponent: any;
    dialogAddCollectionItemComponent: any;
    dialogLocalToCloudComponent: any;
    dialogSearchArchiveComponent: any;
    dialogItemDetailComponent: any;
    dialogStoryItemNotepadItemsComponent: any;
    dialogReportAsProjectComponent: any;
    dialogPublicationComponent: any;
    dialogProjectNewComponent: any;
    dialogReportPreviewComponent: any;
    dialogUserGroupComponent: any;
    dialogUploadInfoComponent: any;
    stageExportLinkDialogComponent: any;
    dialogDevtoolsComponent: any;
    dialogAutouserTransferComponent: any;
    dialogAutouserEditBinaryTreeComponent: any;
    dialogBatchSelectionComponent: any;
    dialogBatchReferencesComponent: any;
    dialogUserGroupListComponent: any;
    dialogUserLicenseComponent: any;
    dialogUnsubscribeComponent: any;
    dialogMemowlWebComponent: any;
    dialogProvidersComponent: any;
    dialogCountdownComponent: any;
    dialogLoginAttentionComponent: any;

    constructor(
        public coords: CoordinatorService,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
    ) {
        let preloaderAttempts = 0;
        const intervalPreloader = setInterval(() => {
            if (++preloaderAttempts > 100 || this.coords.worker$.isReady) {
                document.body.style.backgroundColor = '#fff';
                const preloader =
                    document.getElementById('preloader') ||
                    document.getElementById('preloader_memowl');
                if (preloader) {
                    preloader.style.display = 'none';
                }
                clearInterval(intervalPreloader);
            }
        }, 100);
        this.coords.display$.dialog$.subscribe((x) => {
            if (this.coords.project$.isLoading) return;
            if (x.action === 'close') {
                const stalone = this.coords.display$.standaloneDialog;
                if (stalone) {
                    stalone.close();
                    this.coords.display$.standaloneDialog = undefined;
                    this.coords.display$.markForCheck();
                    return;
                }
                const ec$ = this.coords.databin$.editedConnection$;
                if (ec$.getValue()) ec$.next(undefined);
                this._dialogRef && this._dialogRef.close();
                this.coords.display$.markForCheck();
                return;
            }
            this._miscDialog(x);
        });

        this.coords.display$.markForCheck$.subscribe(() => {
            if (this.coords.project$.current || this._dialogRef) return;
            if (this.coords.display$.isStartDialogOpen) return;
            if (this.coords.display$.isInStepperFlow) return;
            if (!this.isMobile) {
                this._miscDialog({ action: 'start' });
            }
        });
    }

    ngOnInit() {
        const lDiv = document.getElementById('pre-load-screen');
        if (lDiv) {
            lDiv.style.display = 'none';
        }

        this.activatedRoute.queryParams.subscribe((params) => {
            this.coords.display$.markForCheck();
            const eduId: string = params['eduid'];
            const eduiv: string = params['eduiv'];
            const pcode: string = params['pcode'];
            if (eduId) {
                this.coords.display$.isExternalLogin = true;
                this._dialogRef?.close();
                this.coords.eduid$.eduidResponse(eduId, eduiv);
            }

            if (pcode) {
                const newUrl = window.location.protocol + '//' + window.location.host;
                window.history.pushState({ path: newUrl }, '', newUrl);
                this.coords.project$.urlPcode(pcode);
            }
        });
        this.coords.display$.checkScreenTablet();
    }

    ngAfterViewInit() {
        // Trigger lazy load immediately after view init

        import('./dialog-start/dialog-start.component').then((m) => {
            this.dialogStartComponent = m.DialogStartComponent;
        });

        import('./stage-license/stage-license.component').then((m) => {
            this.stageLicenseComponent = m.StageLicenseComponent;
        });

        import('./dialog-bulk/dialog-bulk.component').then((m) => {
            this.dialogBulkComponent = m.DialogBulkComponent;
        });

        import('./stage-manager/stage-manager.component').then((m) => {
            this.stageManagerComponent = m.StageManagerComponent;
        });

        import('./dialog-connection-step1/dialog-connection-step1.component').then((m) => {
            this.dialogConnectionStep1Component = m.DialogConnectionStep1Component;
        });
        import('./dialog-connection-step2/dialog-connection-step2.component').then((m) => {
            this.dialogConnectionStep2Component = m.DialogConnectionStep2Component;
        });
        import('./dialog-connection-step3/dialog-connection-step3.component').then((m) => {
            this.dialogConnectionStep3Component = m.DialogConnectionStep3Component;
        });
        import('./dialog-connection-step4/dialog-connection-step4.component').then((m) => {
            this.dialogConnectionStep4Component = m.DialogConnectionStep4Component;
        });

        import('./section-footer/section-footer.component').then((m) => {
            this.sectionFooterComponent = m.SectionFooterComponent;
        });

        import('./dialog-delete/dialog-delete.component').then((m) => {
            this.dialogDeleteComponent = m.DialogDeleteComponent;
        });

        import('./dialog-user-detail/dialog-user-detail.component').then((m) => {
            this.dialogUserDetailComponent = m.DialogUserDetailComponent;
        });

        import('./dialog-in-progress-actions/dialog-in-progress-actions.component').then((m) => {
            this.dialogInProgressActionsComponent = m.DialogInProgressActionsComponent;
        });

        import('./dialog-open-project-in-progress/dialog-open-project-in-progress.component').then(
            (m) => {
                this.dialogOpenProjectInProgressComponent = m.DialogOpenProjectInProgressComponent;
            },
        );

        import('./dialog-system/dialog-system.component').then((m) => {
            this.dialogSystemComponent = m.DialogSystemComponent;
        });

        import('./dialog-connection-online/dialog-connection-online.component').then((m) => {
            this.dialogConnectionOnlineComponent = m.DialogConnectionOnlineComponent;
        });

        import('./dialog-connection-online/dialog-connection-online.component').then((m) => {
            this.dialogConnectionOnlineComponent = m.DialogConnectionOnlineComponent;
        });

        import('./dialog-logs/dialog-logs.component').then((m) => {
            this.dialogLogsComponent = m.DialogLogsComponent;
        });

        import('./dialog-attachment/dialog-attachment.component').then((m) => {
            this.dialogAttachmentComponent = m.DialogAttachmentComponent;
        });

        import('./dialog-attachment-edit/dialog-attachment-edit.component').then((m) => {
            this.dialogAttachmentEditComponent = m.DialogAttachmentEditComponent;
        });

        import('./dialog-help-in-context/dialog-help-in-context.component').then((m) => {
            this.dialogHelpInContextComponent = m.DialogHelpInContextComponent;
        });

        import('./dialog-mouse-over/dialog-mouse-over.component').then((m) => {
            this.dialogMouseOverComponent = m.DialogMouseOverComponent;
        });

        import('./dialog-menu/dialog-menu.component').then((m) => {
            this.dialogMenuComponent = m.DialogMenuComponent;
        });

        import('./dialog-message/dialog-message.component').then((m) => {
            this.dialogMessageComponent = m.DialogMessageComponent;
        });

        import('./dialog-save/dialog-save.component').then((m) => {
            this.dialogSaveComponent = m.DialogSaveComponent;
        });

        import('./dialog-cloud-cache-conflict/dialog-cloud-cache-conflict.component').then((m) => {
            this.dialogCloudCacheConflictComponent = m.DialogCloudCacheConflictComponent;
        });

        import('./dialog-save-hitset/dialog-save-hitset.component').then((m) => {
            this.dialogSaveHitsetComponent = m.DialogSaveHitsetComponent;
        });

        import('./dialog-search-views/dialog-search-views.component').then((m) => {
            this.dialogSearchViewsComponent = m.DialogSearchViewsComponent;
        });

        import('./dialog-search-binary-tree/dialog-search-binary-tree.component').then((m) => {
            this.dialogSearchBinaryTreeComponent = m.DialogSearchBinaryTreeComponent;
        });

        import('./dialog-confirm/dialog-confirm.component').then((m) => {
            this.dialogConfirmComponent = m.DialogConfirmComponent;
        });

        import('./dialog-export/dialog-export.component').then((m) => {
            this.dialogExportComponent = m.DialogExportComponent;
        });

        import('./dialog-share/dialog-share.component').then((m) => {
            this.dialogShareComponent = m.DialogShareComponent;
        });

        import('./dialog-project-list/dialog-project-list.component').then((m) => {
            this.dialogProjectListComponent = m.DialogProjectListComponent;
        });

        import('./dialog-sort/dialog-sort.component').then((m) => {
            this.dialogSortComponent = m.DialogSortComponent;
        });

        import('./dialog-keyword/dialog-keyword.component').then((m) => {
            this.dialogKeywordComponent = m.DialogKeywordComponent;
        });

        import('./dialog-keyword-group-editor/dialog-keyword-group-editor.component').then((m) => {
            this.dialogKeywordGroupEditorComponent = m.DialogKeywordGroupEditorComponent;
        });

        import(
            './dialog-item-detail-panel-selection/dialog-item-detail-panel-selection.component'
        ).then((m) => {
            this.dialogItemDetailPanelSelectionComponent =
                m.DialogItemDetailPanelSelectionComponent;
        });

        import('./dialog-team-invitation/dialog-team-invitation.component').then((m) => {
            this.dialogTeamInvitationComponent = m.DialogTeamInvitationComponent;
        });

        import('./dialog-team-generate-code/dialog-team-generate-code.component').then((m) => {
            this.dialogTeamGenerateCodeComponent = m.DialogTeamGenerateCodeComponent;
        });
        import('./dialog-team-change-role/dialog-team-change-role.component').then((m) => {
            this.dialogTeamChangeRoleComponent = m.DialogTeamChangeRoleComponent;
        });

        import('./dialog-team-group-invitation/dialog-team-group-invitation.component').then(
            (m) => {
                this.dialogTeamGroupInvitationComponent = m.DialogTeamGroupInvitationComponent;
            },
        );

        import('./dialog-more/dialog-more.component').then((m) => {
            this.dialogMoreComponent = m.DialogMoreComponent;
        });

        import('./dialog-filter-panel-2/dialog-filter-panel-2.component').then((m) => {
            this.dialogFilterPanel2Component = m.DialogFilterPanel2Component;
        });

        import('./dialog-tags-editor/dialog-tags-editor.component').then((m) => {
            this.dialogTagsEditorComponent = m.DialogTagsEditorComponent;
        });

        import('./dialog-ratings-editor/dialog-ratings-editor.component').then((m) => {
            this.dialogRatingsEditorComponent = m.DialogRatingsEditorComponent;
        });

        import('./dialog-login/dialog-login.component').then((m) => {
            this.dialogLoginComponent = m.DialogLoginComponent;
        });

        import('./dialog-logout/dialog-logout.component').then((m) => {
            this.dialogLogoutComponent = m.DialogLogoutComponent;
        });

        import('./dialog-invitation-code-accept/dialog-invitation-code-accept.component').then(
            (m) => {
                this.dialogInvitationCodeAcceptComponent = m.DialogInvitationCodeAcceptComponent;
            },
        );

        import('./dialog-user-identificator/dialog-user-identificator.component').then((m) => {
            this.dialogUserIdentificatorComponent = m.DialogUserIdentificatorComponent;
        });

        import('./dialog-cloud-error/dialog-cloud-error.component').then((m) => {
            this.dialogCloudErrorComponent = m.DialogCloudErrorComponent;
        });

        import('./dialog-column-c-preview/dialog-column-c-preview.component').then((m) => {
            this.dialogColumnCPreviewComponent = m.DialogColumnCPreviewComponent;
        });

        import('./dialog-add-collection-item/dialog-add-collection-item.component').then((m) => {
            this.dialogAddCollectionItemComponent = m.DialogAddCollectionItemComponent;
        });

        import('./dialog-local-to-cloud/dialog-local-to-cloud.component').then((m) => {
            this.dialogLocalToCloudComponent = m.DialogLocalToCloudComponent;
        });

        import('./dialog-search-archive/dialog-search-archive.component').then((m) => {
            this.dialogSearchArchiveComponent = m.DialogSearchArchiveComponent;
        });

        import('./dialog-item-detail/dialog-item-detail.component').then((m) => {
            this.dialogItemDetailComponent = m.DialogItemDetailComponent;
        });

        import('./dialog-report-as-project/dialog-report-as-project.component').then((m) => {
            this.dialogReportAsProjectComponent = m.DialogReportAsProjectComponent;
        });

        import('./dialog-project-new/dialog-project-new.component').then((m) => {
            this.dialogProjectNewComponent = m.DialogProjectNewComponent;
        });

        import('./dialog-report-preview/dialog-report-preview.component').then((m) => {
            this.dialogReportPreviewComponent = m.DialogReportPreviewComponent;
        });

        import('./dialog-open-project-in-progress/dialog-open-project-in-progress.component').then(
            (m) => {
                this.dialogOpenProjectInProgressComponent = m.DialogOpenProjectInProgressComponent;
            },
        );

        import('./dialog-upload-info/dialog-upload-info.component').then((m) => {
            this.dialogUploadInfoComponent = m.DialogUploadInfoComponent;
        });

        import('./stage-export-link-dialog/stage-export-link-dialog.component').then((m) => {
            this.stageExportLinkDialogComponent = m.StageExportLinkDialogComponent;
        });

        import('./dialog-devtools/dialog-devtools.component').then((m) => {
            this.dialogDevtoolsComponent = m.DialogDevtoolsComponent;
        });

        import('./dialog-autouser-transfer/dialog-autouser-transfer.component').then((m) => {
            this.dialogAutouserTransferComponent = m.DialogAutouserTransferComponent;
        });

        import(
            './dialog-autouser-edit-binary-tree/dialog-autouser-edit-binary-tree.component'
        ).then((m) => {
            this.dialogAutouserEditBinaryTreeComponent = m.DialogAutouserEditBinaryTreeComponent;
        });

        import('./dialog-batch-selection/dialog-batch-selection.component').then((m) => {
            this.dialogBatchSelectionComponent = m.DialogBatchSelectionComponent;
        });

        import('./dialog-batch-references/dialog-batch-references.component').then((m) => {
            this.dialogBatchReferencesComponent = m.DialogBatchReferencesComponent;
        });

        import('./dialog-user-group-list/dialog-user-group-list.component').then((m) => {
            this.dialogUserGroupListComponent = m.DialogUserGroupListComponent;
        });

        import('./snackbar-main/snackbar-main.component').then((m) => {
            this.coords.display$.defaultSnackbarComponent = m.SnackbarMainComponent;
        });

        import('./dialog-user-license/dialog-user-license.component').then((m) => {
            this.dialogUserLicenseComponent = m.DialogUserLicenseComponent;
        });

        import('./dialog-unsubscribe/dialog-unsubscribe.component').then((m) => {
            this.dialogUnsubscribeComponent = m.DialogUnsubscribeComponent;
        });

        import('./dialog-memowl-web/dialog-memowl-web.component').then((m) => {
            this.dialogMemowlWebComponent = m.DialogMemowlWebComponent;
        });

        import('./dialog-providers/dialog-providers.component').then((m) => {
            this.dialogProvidersComponent = m.DialogProvidersComponent;
        });

        import('./dialog-countdown/dialog-countdown.component').then((m) => {
            this.dialogCountdownComponent = m.DialogCountdownComponent;
        });

        import('./dialog-login-attention/dialog-login-attention.component').then((m) => {
            this.dialogLoginAttentionComponent = m.DialogLoginAttentionComponent;
        });
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.coords.display$.click$.next(event);
    }

    private get _dialogRef(): MatDialogRef<any> | undefined {
        return this.dialog.openDialogs.length == 0
            ? undefined
            : this.dialog.openDialogs[this.dialog.openDialogs.length - 1];
    }

    private async _miscDialog(params: any) {
        let cls;
        if (this.coords.display$.isExternalLogin) return;
        switch (params.action) {
            case 'connection-step':
                switch (params.step) {
                    case 1:
                        cls = this.dialogConnectionStep1Component;
                        break;
                    case 2:
                        cls = this.dialogConnectionStep2Component;
                        break;
                    case 3:
                        cls = this.dialogConnectionStep3Component;
                        break;
                    case 4:
                        cls = this.dialogConnectionStep4Component;
                        break;
                }
                break;
            case 'delete':
                cls = this.dialogDeleteComponent;
                params.isNarrow = true;
                break;
            case 'user-detail':
                cls = this.dialogUserDetailComponent;
                break;
            case 'user-license':
                cls = this.dialogUserLicenseComponent;
                break;
            case 'in-progress':
                cls = this.dialogInProgressActionsComponent;
                break;
            case 'start':
                if (!this.coords.worker$.isReady) return;
                if (this.coords.display$.isStartDialogOpen || this.coords.isLicenseManager) return;
                if (params?.forceStart) {
                    cls = this.dialogStartComponent;
                } else {
                    const skipLoginPrompt =
                        localStorage.getItem(this._skipLoginPromptKey) === '1';
                    cls =
                        this.coords.user$.isLogged || skipLoginPrompt
                            ? this.dialogStartComponent
                            : this.dialogLoginComponent;
                    if (cls === this.dialogLoginComponent) {
                        params.isNarrow = true;
                    }
                }
                if (cls === this.dialogStartComponent) {
                    delete params.isNarrow;
                }
                break;
            case 'system':
                cls = this.dialogSystemComponent;
                break;
            case 'connection-online':
                cls = this.dialogConnectionOnlineComponent;
                break;
            case 'connection-script':
                cls = this.dialogConnectionScriptComponent;
                break;
            case 'attention':
                cls = this.dialogLoginAttentionComponent;
                params.isNarrow = true;
                break;
            case 'bulk':
                cls = this.dialogBulkComponent;
                params.isWide = true;
                break;
            case 'logs':
                cls = this.dialogLogsComponent;
                params.isWide = true;
                break;
            case 'attachment':
                cls = this.dialogAttachmentComponent;
                params.isWide = true;
                break;
            case 'edit-attachment':
                cls = this.dialogAttachmentEditComponent;
                params.isWide = true;
                break;
            case 'edit-image':
                cls = this.dialogImageComponent;
                params.isWide = true;
                break;
            case 'help-in-context':
                cls = this.dialogHelpInContextComponent;
                params.isWide = true;
                params.disableClose = true;
                this.coords.display$.helpDialog = this.dialog.open(cls, this._dialogConfig(params));
                return;
            case 'mouse-over':
                cls = this.dialogMouseOverComponent;
                params.disableBackdrop = true;
                params.isSmall = true;
                this.coords.display$.mouseOverDialog = this.dialog.open(
                    cls,
                    this._dialogConfig(params),
                );
                return;
            case 'unsubscribe':
                cls = this.dialogUnsubscribeComponent;
                break;
            case 'menu':
                cls = this.dialogMenuComponent;
                params.disableBackdrop = true;
                params.disableClose = true;
                params.isMenu = true;
                const md = this.coords.display$.menuDialog;
                md && md.close();
                if (this.coords)
                    this.coords.display$.menuDialog = this.dialog.open(
                        cls,
                        this._dialogConfig(params),
                    );
                return;
            case 'message':
                cls = this.dialogMessageComponent;
                params.isWide = true;
                break;
            case 'save':
                cls = this.dialogSaveComponent;
                break;
            case 'cache-conflict':
                cls = this.dialogCloudCacheConflictComponent;
                break;
            case 'save-hitset':
                cls = this.dialogSaveHitsetComponent;
                break;
            case 'search-view':
                cls = this.dialogSearchViewsComponent;
                break;
            case 'search-binary-tree':
                cls = this.dialogSearchBinaryTreeComponent;
                break;
            case 'confirm':
                cls = this.dialogConfirmComponent;
                break;
            case 'export':
                cls = this.dialogExportComponent;
                params.isNarrow = true;
                break;
            case 'share':
                cls = this.dialogShareComponent;
                break;
            case 'project-list':
                cls = this.dialogProjectListComponent;
                break;
            case 'sort':
                cls = this.dialogSortComponent;
                params.isNarrow = true;
                break;
            case 'keyword':
                cls = this.dialogKeywordComponent;
                break;
            case 'keyword-group':
                cls = this.dialogKeywordGroupEditorComponent;
                break;
            case 'dataset-visible-panels':
                cls = this.dialogItemDetailPanelSelectionComponent;
                params.isNarrow = true;
                break;
            case 'team-invitation':
                cls = this.dialogTeamInvitationComponent;
                break;
            case 'team-generate':
                cls = this.dialogTeamGenerateCodeComponent;
                params.isNarrow = true;
                break;
            case 'team-change-role':
                cls = this.dialogTeamChangeRoleComponent;
                params.isNarrow = true;
                params.data = { element: params.element };
                break;
            case 'team-group-invitation':
                cls = this.dialogTeamGroupInvitationComponent;
                break;
            case 'more':
                cls = this.dialogMoreComponent;
                break;
            case 'filter-panel-2':
                cls = this.dialogFilterPanel2Component;
                params.isWide = true;
                break;
            case 'tags-editor':
                cls = this.dialogTagsEditorComponent;
                break;
            case 'ratings-editor':
                cls = this.dialogRatingsEditorComponent;
                break;
            case 'login':
                cls = this.dialogLoginComponent;
                break;
            case 'logout':
                cls = this.dialogLogoutComponent;
                break;
            case 'accept-code':
                cls = this.dialogInvitationCodeAcceptComponent;
                break;
            case 'providers':
                cls = this.dialogProvidersComponent;
                break;
            case 'user-identificators':
                cls = this.dialogUserIdentificatorComponent;
                break;
            case 'cloud-error':
                cls = this.dialogCloudErrorComponent;
                break;
            case 'column_c':
                cls = this.dialogColumnCPreviewComponent;
                break;
            case 'add-collection-item':
                cls = this.dialogAddCollectionItemComponent;
                break;
            case 'local-to-cloud':
                cls = this.dialogLocalToCloudComponent;
                params.isWide = true;
                break;
            case 'memowl-web':
                cls = this.dialogMemowlWebComponent;
                params.isWide = true;
                break;
            case 'search-archive':
                cls = this.dialogSearchArchiveComponent;
                params.isWide = true;
                break;
            case 'xitem':
                cls = this.dialogItemDetailComponent;
                params.isFull = true;
                break;
            case 'project-export':
            case 'report-project':
                cls = this.dialogReportAsProjectComponent;
                params.isWide = true;
                break;
            case 'publication':
                cls = this.dialogPublicationComponent;
                params.isWide = true;
                break;
            case 'project-new':
                cls = this.dialogProjectNewComponent;
                params.isWide = true;
                break;
            case 'report-project-preview':
                cls = this.dialogReportPreviewComponent;
                params.isWide = true;
                break;
            case 'user-group':
                cls = this.dialogUserGroupComponent;
                params.isWide = true;
                break;
            case 'user-group-list':
                cls = this.dialogUserGroupListComponent;
                params.isWide = true;
                break;
            case 'open-project-in-progress':
                cls = this.dialogOpenProjectInProgressComponent;
                params.isStart = true;
                break;
            case 'upload-info':
                cls = this.dialogUploadInfoComponent;
                params.isWide = true;
                break;
            case 'export-project-link':
                cls = this.stageExportLinkDialogComponent;
                break;
            case 'devtools':
                cls = this.dialogDevtoolsComponent;
                break;
            case 'autouser-transfer':
                cls = this.dialogAutouserTransferComponent;
                params.isWide = true;
                break;
            case 'autouser-edit-bt':
                cls = this.dialogAutouserEditBinaryTreeComponent;
                params.isWide = true;
                break;
            case 'batch-select':
                cls = this.dialogBatchSelectionComponent;
                params.isWide = true;
                break;
            case 'batch-references':
                cls = this.dialogBatchReferencesComponent;
                params.isWide = true;
                break;
            case 'countdown':
                cls = this.dialogCountdownComponent;
                break;
            default:
                return console.log('UNKNOWN', params);
        }

        if (!cls) {
            setTimeout(() => {
                console.log('RETRY DIALOG', params);
                this._miscDialog(params);
            }, 30);
            return;
        }

        this.coords.display$.lastDialogAction = params.action;
        this._open(cls, params);
    }

    private _open(cls: any, params: any) {
        if (!params.isStandalone && !this.coords.display$.isInStepperFlow) {
            this.dialog.closeAll();
        }
        const d = this.dialog.open(cls, this._dialogConfig(params));
        if (params.isStandalone) this.coords.display$.standaloneDialog = d;
    }

    _dialogConfig(params: any) {
        const panelLs = ['modal-Panel'];
        const backdropLs = ['modal-Backdrop'];
        if (params.isNarrow) {
            panelLs.push('narrow');
        } else if (params.isWide) {
            panelLs.push('wide');
        } else if (params.isFull) {
            panelLs.push('full');
        } else if (params.isSmall) {
            panelLs.push('small');
        } else if (params.isMenu) {
            panelLs.push('menu');
        } else if (params.isStart) {
            panelLs.push('start_dialog');
            backdropLs.push('start_dialog_backdrop');
        }
        if (params.isMenu) {
            if (params.position.left) {
                const oldLeft = parseInt(params.position.left);
                const viewportWidth = window.innerWidth;
                const fromRight = 150;
                if (oldLeft + fromRight > viewportWidth) {
                    params.position.left = `${viewportWidth - fromRight}px`;
                }
            }
        }

        const clsLs = [params.action, params.type].filter((x) => x);

        clsLs.forEach((x) => {
            panelLs.push(`my-panel-${x}`);
            backdropLs.push(`my-backdrop-${x}`);
        });

        return Object.assign(
            {
                disableClose: params.disableClose || !this.coords.project$.current,
                autoFocus: false,
                data: params,
                panelClass: panelLs,
                hasBackdrop: !params.disableBackdrop,
                backdropClass: backdropLs,
            },
            params,
        );
    }

    @HostListener('document:keyup', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.coords.keyboard$.keyup(event);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.coords.display$.checkScreenTablet();
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;
        if (!this.isMobile && wasMobile) {
            this._miscDialog({ action: 'start' });
        }
        if (this.isMobile && !wasMobile) {
            this.dialog.closeAll();
        }
    }
}
